import { Flex, Typography } from 'antd';
import React from 'react';

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  description?: string;
  extra?: React.ReactNode;
}

export default function PageHeader({
  title,
  description,
  extra,
}: PageHeaderProps) {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      wrap="wrap"
      gap={12}
      style={{ marginBottom: 20 }}
    >
      <div>
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
        {description && (
          <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
            {description}
          </Text>
        )}
      </div>
      {extra}
    </Flex>
  );
}
